import { render, staticRenderFns } from "./ProductCards.vue?vue&type=template&id=65103802&scoped=true"
import script from "./ProductCards.vue?vue&type=script&lang=js"
export * from "./ProductCards.vue?vue&type=script&lang=js"
import style0 from "./ProductCards.vue?vue&type=style&index=0&id=65103802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65103802",
  null
  
)

export default component.exports